import React, {useRef} from 'react';
import {QRCodeCanvas} from 'qrcode.react';
import kra_icon from "../static_files/KRA.svg"
import qrBorder_icon from "../static_files/qrBorder.svg"

import styles from './KiraQRCodeModal.module.css';
import DownloadQRCodeButton from "./DownloadQRCodeButton"; // 您可以自定义CSS样式

/**
 * 示例属性 (props):
 *  isOpen: Boolean - 控制弹窗是否显示
 *  onClose: Function - 关闭弹窗时的回调
 *  referralUrl: String - 要生成二维码的链接, 如 https://app.kira.trading/invite-friend/xxx
 */
function KiraQRCodeModal({isOpen, onClose, referralUrl}) {
    const qrRef = useRef(null);

    if (!isOpen) return null;

    const handleDownloadQR = () => {
        if (!qrRef.current) return;
        const canvas = qrRef.current.querySelector('canvas');
        if (!canvas) return;

        const pngUrl = canvas
            .toDataURL('image/png')
            .replace('image/png', 'image/octet-stream');

        const downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = 'KiraTrading_QR.png';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    return (
        <div
            className={styles.modalBackdrop}
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <div className={styles.modalContainer}>
                {/* 右上角关闭按钮 */}
                <button className={styles.closeButton} onClick={onClose}>
                    &times;
                </button>

                {/* 头像 + 标题 */}
                <div className={styles.header}>
                    <img
                        className={styles.avatar}
                        src={kra_icon}
                        alt='Kira Trading Logo'
                    />
                    <h2 className={styles.title}>Kira Trading</h2>
                </div>

                <h3 className={styles.subtitle}>Hey!</h3>
                <p className={styles.description}>
                    Scan the QR to register to Kira Trading<br/>
                    and start earning interests today!
                </p>

               <div className={styles.qrOuterContainer}>
  <img src={qrBorder_icon} className={styles.qrBorder} alt="QR Border" />
  <div className={styles.qrWrapper} ref={qrRef}>
    <QRCodeCanvas
      value={referralUrl || 'https://app.kira.trading'}
      size={192}
      bgColor='#FFFFFF'
      fgColor='#000000'
      includeMargin={true}
      level='M'
    />
  </div>
</div>

               <DownloadQRCodeButton onClick={handleDownloadQR} />
            </div>
        </div>
    );
}

export default KiraQRCodeModal;